import React, { Fragment } from "react";
import { Box } from "grid-styled";
import { P } from "./Text";
import { LinkButton } from "./Button";

const NotFound = ({ children, ...otherProps }) => (
  <Box p={3} {...otherProps}>
    {children || (
      <Fragment>
        <P>It looks like this page doesn't exist.</P>
        <LinkButton primary to="/">
          Go to home page
        </LinkButton>
      </Fragment>
    )}
  </Box>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js